module.exports = __webpack_public_path__ + "img/logo.fae13ada.png";